/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Fragment, useState, useEffect } from 'react';

import { graphql, useStaticQuery, Link } from 'gatsby';

import { FiMoreVertical } from 'react-icons/fi';
import { IoMdClose } from 'react-icons/io';

export const query = graphql`
  query SidebarQuery {
    allSanityCategory {
      edges {
        node {
          slug {
            current
          }
          id
          name
        }
      }
    }
  }
`;

const Sidebar = () => {
  const data = useStaticQuery(query);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const mediaQuery = window.matchMedia('(max-width: 576px)');

      if (mediaQuery.matches) {
        setIsMobile(true);
      }

      const handleScreen = e => {
        if (e.matches) {
          setIsMobile(true);
        } else {
          setIsMobile(false);
        }
      };

      mediaQuery.addListener(handleScreen);

      return () => mediaQuery.removeListener(handleScreen);
    }

    return () => {};
  }, []);

  const handleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Fragment>
      <aside className={`sidebar ${sidebarOpen && isMobile ? 'sidebar-open' : ''}`}>
        <div className="content">
          {isMobile && (
            <button type="button" onClick={() => handleSidebar()} className="button">
              {sidebarOpen ? <IoMdClose /> : <FiMoreVertical />}
            </button>
          )}
          <div className="section">
            <h4>Categories</h4>
            <ul className="list">
              {data?.allSanityCategory.edges.map(({ node: { name, slug } }) => {
                return (
                  <li key={`li-${slug.current}`}>
                    <Link
                      className="link"
                      activeClassName="link-active"
                      to={`/category/${slug.current}`}
                    >
                      {name}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </aside>
    </Fragment>
  );
};

export default Sidebar;
